module.exports = __webpack_public_path__ + "media/entities/1111-e057bbb1.png";